import React, {useState} from "react"
import styled from "styled-components"
import {TweenMax, Power3} from 'gsap'
import fonts from "../../fonts"
import breakpoints from "../../styles/breakpoints"
import Wrapper from "../grid/wrapper"
import Row from "../grid/row"
import Column from "../grid/column"
import arrow from "../../images/arrow-slider.svg"
import SliderShowroomData from '../../data/sliderShowroomData'
import ScrollAnimation from "react-animate-on-scroll"
import Video from "../video"
import colors from "../../styles/colors"
import InstagramIcon from "../../images/ico-instagram-dark.svg"


const Anchor = styled.div`
    display: block;
    position: relative;
    top: -60px;
    visibility: hidden;
`

const SliderTitle = styled.h2`
    font-size: 48px;
    line-height: 50px;
    font-family: ${fonts.roca};
    font-weight: bold;
    text-align: center;
    margin: 0 auto 20px;

    @media ${breakpoints.tablet} {
        margin: 0 auto 40px;
    }
`

const SliderDesc = styled.p`
    font-family: ${fonts.helvetica};
    font-size: 16px;
    line-height: 24px;
    text-align: center;
`

const ShowroomVideoContainer = styled.div`
    margin-bottom: 40px;
`
const ShowroomInstagram = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
`


const ShowroomInstagramLink = styled.a`
display: flex;
align-items: center;
font-weight: bold;
font-size: 18px;
line-height: 24px;
color: ${colors.tertiaryDark};
transition: all 0.4s ease;
opacity: 1;
text-decoration:none;
margin-bottom: 20px;
:hover {
  opacity: 0.6;
}
`

const Icon = styled.img`
width: 36px;
margin-right: 10px;
`

const InstagramText = styled.h5`
    span{
      display:block;
      font-size: 12px;
      line-height: 12px;
    }
`

const Slider = styled.div`
    display: flex;
    align-items: center;

    position: relative;
    left: 0;
    width: 100%;

    margin: 0 -1px;
    margin-top: 40px;

    @media ${breakpoints.tablet} {
        max-height: inherit;
        margin-top: 60px;
    }

    img {
        min-width: 100%;
        padding: 0 1px;
        object-fit: cover;
        max-width: 100%;
    }
`

const ServiceSliderNavSwitchLeft = styled.div`
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -23px;
    
    margin-top: -30px;
    
    user-select: none;
    z-index: 1;

    transform: rotate(180deg);

    border-radius: 50%;
    /* box-shadow: 0px 2px 19px 0px rgba(0,0,0, .2); */
    transition: .4s;

    &:hover {
        opacity: .8;
    }
`

const ServiceSliderNavSwitchRight = styled.div`
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -23px;
    margin-top: -30px;
    user-select: none;
    z-index: 1;
    border-radius: 50%;
    /* box-shadow: 0px 2px 19px 0px rgba(0,0,0, .2); */
    transition: .4s;

    &:hover {
        opacity: .8;
    }
`



const SliderShowroom = () => {

    const [index, setIndex] = useState(0)

    const animate = (i) => {
        
        const slider = document.getElementsByClassName('slide')

        TweenMax.to(slider, 1.4, {
            autoAlpha: 1,
            x: (index+ i) * 100 + '%',
            ease: Power3.easeInOut,
        })
    }

    const handlePrevious = i => {
        setIndex(index + i)
        animate(i)
    }

    const handleNext = i => {
        setIndex(index + i)
        animate(i)
    }

    return ( 
        <section>
            <Anchor id="showroom"/>
            <Wrapper>
                <Row>
                  <Column xs={10} align="center">
                    <SliderTitle>
                      <ScrollAnimation animateIn="fadeIn">
                        Roca Experience Center Indonesia
                      </ScrollAnimation>
                    </SliderTitle>
                  </Column>
                  <Column xs={12} align="center">
                    <ScrollAnimation animateIn="fadeIn">
                        <ShowroomVideoContainer>
                          <Video
                            videoSrcURL="https://www.youtube.com/embed/1ZWm6dmhl_I"
                            videoTitle="Roca Experience Center Indonesia"
                          />
                        </ShowroomVideoContainer>
                    </ScrollAnimation>
                  </Column>
                  <Column xs={10} align="center">
                    <ScrollAnimation animateIn="fadeIn">
                      <SliderDesc>
                        Roca Experience Center Indonesia, merupakan pusat konsep kamar mandi inovatif dengan berbagai macam inspirasi desain untuk kamar mandi. Roca Experience Center menampilkan berbagai macam produk kamar mandi lengkap yang mengedepankan desain, kenyamanan, fungsionalitas, serta ramah lingkungan.
                      </SliderDesc>
                      <SliderDesc>
                        Di Roca Experience Center, konsumen dapat merasakan dan melihat langsung produk-produk milik Roca. Selain itu, Roca Experience Center ini merupakan sebuah bukti dari komitmen Roca terhadap industri desain dan arsitektur.
                      </SliderDesc>
                      <SliderDesc>
                        Para arsitek, desainer interior maupun <em>developer</em> dapat menggunakan Roca Experience Center untuk mengadakan <em>meeting</em>. Roca Experience center juga memiliki tempat khusus untuk pameran, dan <em>event</em> space yang terbuka untuk bagi profesional dan masyarakat umum.
                      </SliderDesc>
                    </ScrollAnimation>
                  </Column>
                  <Column xs={10} align="center">
                    <ShowroomInstagram>
                      <ShowroomInstagramLink target="_blank" href="https://www.instagram.com/rocaexperience_id">
                        <Icon alt="instagram-icon" src={InstagramIcon} />
                        <InstagramText>
                          <span>Follow us on Instagram</span>
                          @rocaexperience_id
                        </InstagramText>
                      </ShowroomInstagramLink>
                    </ShowroomInstagram>
                  </Column>
                  <Column xs={12}>
                    <ScrollAnimation animateIn="fadeInRight">
                      <Slider>
                        {SliderShowroomData.map((fabrica, idx) => (
                            <img className="slide" alt="fabrica 1" src={fabrica} key={idx}/>
                        ))}
                        
                        {index !== 0 && <ServiceSliderNavSwitchLeft onClick={() => handlePrevious(1)}>
                            <img src={arrow} alt="Previous" />
                        </ServiceSliderNavSwitchLeft>}

                        {-index !== SliderShowroomData.length - 1 && <ServiceSliderNavSwitchRight onClick={() => handleNext(-1)}>
                            <img src={arrow} alt="Next" />
                        </ServiceSliderNavSwitchRight>}
                      </Slider>
                    </ScrollAnimation>
                  </Column>
                </Row>
            </Wrapper>
        </section>
     )
}
 
export default SliderShowroom;